// Colors

export const ColorHaiti = '#0A0F2C'
export const ColorHarlequin = '#27E200'
export const ColorWhite = '#FFFFFF'
export const ColorStormGray = '#6F717D'
export const ColorLightGrey = '#D6D3CF'
export const ColorDustyGray = '#9B9B9B'
